import { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth, db } from "./firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";

const AuthCtx = createContext(null);

async function ensureUserDoc() {
  if (!auth.currentUser || !auth.currentUser.email) return;
  const email = auth.currentUser.email.toLowerCase();
  const ref = doc(db, "users", email);
  const snap = await getDoc(ref);
  if (!snap.exists()) {
    await setDoc(ref, { email, role: "user" }, { merge: true });
  }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);
  const [role, setRole] = useState(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u || null);
      setReady(true);
    });
    return unsub;
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (user && user.email) {
        await ensureUserDoc();
        const ref = doc(db, "users", user.email.toLowerCase());
        const snap = await getDoc(ref);
        const r = snap.exists() && typeof snap.data().role === "string" ? snap.data().role : "user";
        if (!cancelled) setRole(r);
      } else {
        setRole("user");
      }
    })();
    return () => { cancelled = true; };
  }, [user]);

  function logout() {
    return signOut(auth);
  }

  return (
    <AuthCtx.Provider value={{ user, role, ready, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
